import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";
import type { IncomeOtpMode } from "modules/Salary/types/incomeOtpMode";

export type VerifyIncomeOtpPayload = {
  otp: string;
  mode: IncomeOtpMode;
};

interface InitialState {
  status: ReduxStateType;
  section: string | null;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  section: null,
};

const verifyIncomeOtpSlice = createSlice({
  name: "salary/verifyIncomeOtp",
  initialState,
  reducers: {
    verifyIncomeOtpStart: (
      state,
      _action: PayloadAction<VerifyIncomeOtpPayload>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    verifyIncomeOtpSuccess: (
      state,
      action: PayloadAction<{ section: string }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.section = action.payload.section;
    },
    verifyIncomeOtpFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    clearVerifyIncomeOtpStatus: (state) => {
      state.status = ReduxStateType.INIT;
    },
    resetVerifyIncomeOtp: () => initialState,
  },
});

export const {
  verifyIncomeOtpStart,
  verifyIncomeOtpSuccess,
  verifyIncomeOtpFailed,
  clearVerifyIncomeOtpStatus,
  resetVerifyIncomeOtp,
} = verifyIncomeOtpSlice.actions;

export default verifyIncomeOtpSlice.reducer;
